var React = require('react');
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var PureRenderMixin = require('react-addons-pure-render-mixin');
var DatePicker = require('./datePicker.jsx');
var Callout = require('./callout.jsx');

var PartialRegister = createReactClass({
  mixins: [PureRenderMixin],

  getInitialState: function () {
    return {
      dob: '1/1/' + new Date().getFullYear(),
      gender: '',
    };
  },

  componentWillUnmount: function () {
    this.props.clearRegError();
  },

  handleDateChange: function (month, day, year) {
    this.setState({ dob: month + '/' + day + '/' + year });
  },

  handleGenderChange: function (event) {
    var selectEle = event.currentTarget;
    this.setState({ gender: selectEle.options[selectEle.selectedIndex].value });
  },

  handleSubmit: function (event) {
    event.preventDefault();
    var firstName = this.refs.firstName.value.trim();
    var lastName = this.refs.lastName.value.trim();
    var email = this.refs.email.value.trim().toLowerCase();
    var dob = this.state.dob;
    var postalCode = this.refs.postalCode.value.trim();

    this.props.partialSignUp(
      firstName,
      lastName,
      email,
      this.state.gender,
      dob,
      postalCode,
      this.props.loginRedirectUrl,
      this.props.analyticsLabelSuffix
    );
  },

  handleClickTracking: function (event) {
    var target = event.target;
    var label =
      target.innerText +
      (this.props.analyticsLabelSuffix
        ? ' ' + this.props.analyticsLabelSuffix
        : '');
    var action = 'Click';

    if (label === 'Complete Registration') {
      action = 'Submit';
      label =
        'Email' +
        (this.props.analyticsLabelSuffix
          ? ' ' + this.props.analyticsLabelSuffix
          : '');
    }

    this.props.recordRegisterClick(action, label);
  },

  render: function () {
    var errorMsg =
      this.props.auth &&
      Object.keys(this.props.auth.error).length > 0 &&
      (this.props.auth.error.message
        ? this.props.auth.error.message
        : this.props.auth.error.toString());

    var date = new Date(this.state.dob);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    return (
      <div className="special-form-box-wrapper">
        <div className="register-box special-form-box">
          <h1>Sign Up</h1>
          {errorMsg && (
            <Callout
              type="alert"
              message={errorMsg}
              handleClose={this.props.clearRegError}
            />
          )}
          <div className="form">
            <form onSubmit={this.handleSubmit} noValidate autoComplete="off">
              <div className="input-field-wrapper">
                <div className="input-field">
                  <label className="heading" htmlFor="firstName">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    ref="firstName"
                    placeholder="John"
                    required
                  />
                </div>
                <div className="input-field">
                  <label className="heading" htmlFor="lastName">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    ref="lastName"
                    placeholder="Smith"
                    required
                  />
                </div>
                <div className="input-field">
                  <label className="heading" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    ref="email"
                    placeholder="john@example.com"
                    required
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="input-field-wrapper">
                <div className="postalCode-input-field input-field">
                  <label className="heading" htmlFor="postalCode">
                    ZIP Code
                  </label>
                  <input
                    type="text"
                    name="postalCode"
                    id="postalCode"
                    ref="postalCode"
                    placeholder="ZIP Code"
                    required
                    autoComplete="off"
                  />
                  <div className="tip">
                    <span className="ion-ios-information-outline"></span>
                    <p>
                      Your location helps us find relevant clinical trials near
                      you
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={
                  'gender-picker input-field-wrapper ' + this.state.gender
                }
              >
                <div className="input-field">
                  <label className="heading" htmlFor="gender">
                    Gender
                  </label>
                  <div className="select-container">
                    <select
                      name="gender"
                      id="gender"
                      ref="gender"
                      value={this.state.gender}
                      onChange={this.handleGenderChange}
                    >
                      <option value="">Select Your Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                </div>
              </div>

              <p className="input-field-title">Birthdate</p>
              <DatePicker
                month={month}
                day={day}
                year={year}
                onDateChange={this.handleDateChange}
              />

              <div id="agree-to-terms">
                <p>
                  By continuing you are agreeing to the <br />
                  <Link to="/terms" onClick={this.handleClickTracking}>
                    Terms and Conditions
                  </Link>
                </p>
              </div>

              <button
                className="button success expanded"
                type="submit"
                onClick={this.handleClickTracking}
              >
                Continue
              </button>

              <br />

              <p className="text-center">
                Already have an Account?{' '}
                <Link to="/login" onClick={this.handleClickTracking}>
                  Sign In
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    );
  },
});

module.exports = PartialRegister;



// WEBPACK FOOTER //
// ./src/common/routes/components/partialRegisterBox.jsx